import { relationGroupsConstants } from '../../_constants';

const initialState = { userRelationGroupLoading: true, data: '', error: false };

export function userRelationGroupReducer(state = initialState, action) {

  switch (action.type) {
    case relationGroupsConstants.REQUEST_USER_RELATION_GROUP:
      return {
        userRelationGroupLoading: true,
        data: '',
        error: false
      };
    case relationGroupsConstants.RECEIVE_USER_RELATION_GROUP:

      return {
        userRelationGroupLoading: false,
        data: action.relationGroup,
        error: false
      };
    case relationGroupsConstants.USER_RELATION_GROUP_ERROR:


      return {
        userRelationGroupLoading: false,
        data: action.error,
        error: true
      };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/relationGroups/userRelationGroup.reducer.js